import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { ELEMENTOS } from '../../data/retiro';
export function Elementos() {
  return <section id="elementos" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-47">
      <div className="mx-auto max-w-7xl" data-id="element-48">
        <SectionHeading eyebrow="Los Cuatro Elementos" title="Un camino de purificación a través del agua, el fuego, el aire y la tierra" data-id="element-49" />

        <div className="mt-20 flex flex-col gap-20 md:gap-28" data-id="element-50">
          {ELEMENTOS.map((el, i) => {
          const reverse = i % 2 === 1;
          return <div key={el.nombre} className="grid items-center gap-10 md:grid-cols-2 md:gap-16" data-id="element-51">
                <Reveal className={reverse ? 'md:order-2' : ''} data-id="element-52">
                  <div className="relative overflow-hidden rounded-[2rem]" data-id="element-53">
                    <img src={el.imagen} alt={`Elemento: ${el.nombre} — ${el.titulo}`} className="aspect-[4/5] w-full object-cover" data-id="element-54" />
                    <div className="absolute inset-x-0 bottom-0 h-1/3" style={{
                  background: 'linear-gradient(180deg, transparent 0%, rgba(42,36,32,0.5) 100%)'
                }} data-id="element-55" />
                    <span className="absolute left-6 top-6 text-5xl" data-id="element-56">
                      {el.emoji}
                    </span>
                  </div>
                </Reveal>

                <Reveal delay={0.1} className={reverse ? 'md:order-1' : ''} data-id="element-57">
                  <span className="text-xs font-medium uppercase tracking-[0.28em]" style={{
                color: el.acento
              }} data-id="element-58">
                    {el.numero}
                  </span>
                  <h3 className="mt-3 font-heading text-2xl font-light sm:text-3xl" style={{
                color: 'var(--ink)'
              }} data-id="element-59">
                    {el.nombre}
                    <span className="block text-lg" style={{
                  color: 'rgba(42,36,32,0.55)'
                }} data-id="element-60">
                      {el.titulo}
                    </span>
                  </h3>

                  <ul className="mt-6 space-y-4" data-id="element-61">
                    {el.puntos.map(p => <li key={p.titulo} data-id="element-62">
                        <span className="font-medium" style={{
                    color: 'var(--ink)'
                  }} data-id="element-63">
                          {p.titulo}.{' '}
                        </span>
                        <span style={{
                    color: 'rgba(42,36,32,0.72)'
                  }} data-id="element-64">
                          {p.texto}
                        </span>
                      </li>)}
                  </ul>

                  <blockquote className="mt-7 border-l-2 pl-5 font-heading text-base font-light italic leading-relaxed" style={{
                borderColor: el.acento,
                color: 'var(--ink)'
              }} data-id="element-65">
                    {el.cita}
                  </blockquote>
                </Reveal>
              </div>;
        })}
        </div>
      </div>
    </section>;
}